import * as Yup from 'yup';

export default Yup.object().shape({
  cf_price: Yup.string().required('Required'),
  carrier_driver_id: Yup.number().nullable().required('Required'),
  carrier_id: Yup.number().required('Required'),
  job_id: Yup.number().required('Required'),
});
